
import PauseCircle from "../../../assets/outline/PauseCircle.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function PauseCircleIcon({ className, dataTestid = "PauseCircleIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <PauseCircle data-testid={dataTestid} className={classes} {...rest} />
  );
}
